import {createContext, useContext} from "react";
import ReactPDF from "@react-pdf/renderer";

export const CorporateRegStyleContext = createContext<ReactPDF.Styles>({});
export const useCorporateRegStyle = () => useContext(CorporateRegStyleContext);